import {
  IGuideFilterOptionsWithRangeSkills,
  IAssignGuideTourSkill,
  IAssignGuideRangeTourSkill,
  IGuideFilterOptions,
} from 'static/interfaces'
import { SKILL_LEVELS } from 'static/constants'
const maxLevel = Math.max(...Object.keys(SKILL_LEVELS).map(Number))
const minLevel = Math.min(...Object.keys(SKILL_LEVELS).map(Number))

export const convertLevelToRange = (level: string, condition_type: string) => {
  switch (condition_type) {
    case 'gte':
      return {
        min_level: Number(level),
        max_level: maxLevel,
      }

    case 'lte':
      return {
        min_level: minLevel,
        max_level: Number(level),
      }
    case 'exact':
      return {
        min_level: Number(level),
        max_level: Number(level),
      }
    default:
      return { min_level: 0, max_level: 999 }
  }
}

const convertAssignGuideTourSkillsToRange = (
  assignGuideTourSkills: IAssignGuideTourSkill[]
): IAssignGuideRangeTourSkill[] => {
  return assignGuideTourSkills.map(agts => {
    const { min_level, max_level } = convertLevelToRange(
      agts.level || '',
      agts.condition_type || ''
    )
    return {
      ...agts,
      min_level,
      max_level,
    }
  })
}

/**
 * フィルタオプションをAPI送信用形式に変換
 * - ツアー情報追加
 * - UI側で選択されたガイドスキルのレベル条件を範囲形式に変換
 */
export const formatGuideFilterOptionsForAPI = (
  filterOptions: IGuideFilterOptions,
  tour: {
    post_id: number
    day: string
    start_time: string
  }
): IGuideFilterOptionsWithRangeSkills => {
  const convertedAssignGuideTourSkills = convertAssignGuideTourSkillsToRange(
    filterOptions.assign_guide_tour_skills || []
  )
  if (!tour) {
    return {
      ...filterOptions,
      assign_guide_tour_skills: convertedAssignGuideTourSkills,
    }
  }
  return {
    post_id: tour.post_id,
    day: tour.day,
    start_time: tour.start_time,
    ...filterOptions,
    assign_guide_tour_skills: convertedAssignGuideTourSkills,
  }
}
